import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ProjectFramework } from '../models';

@Injectable({ providedIn: 'root' })
export class FrameworkService {
  private readonly apiUrl = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getAll(): Observable<ProjectFramework[]> {
    return this.http.get<ProjectFramework[]>(`${this.apiUrl}/frameworks`);
  }

  create(code: string, name?: string, defaultStartPhase = 'Initiation'): Observable<ProjectFramework> {
    return this.http.post<ProjectFramework>(`${this.apiUrl}/frameworks`, { code, name, defaultStartPhase });
  }

  update(id: number, code: string, name: string | undefined, defaultStartPhase: string): Observable<ProjectFramework> {
    return this.http.put<ProjectFramework>(`${this.apiUrl}/frameworks/${id}`, { code, name, defaultStartPhase });
  }

  deactivate(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/frameworks/${id}`);
  }

  updateOrder(frameworkIds: number[]): Observable<ProjectFramework[]> {
    return this.http.put<ProjectFramework[]>(`${this.apiUrl}/frameworks/order`, { frameworkIds });
  }
}
